import React, { useContext } from "react";
import { Container, Title, Checklist, Button, StyledDoThisLater } from "./setup.style";
import ListItem from "./ListItem";
import FixelDataContext from "../../context/FixelDataContext";
import { useHistory } from "react-router-dom";
import { ReactComponent as SetupAccount } from "./img/SetupAccount.svg";

const Setup = () => {
  const history = useHistory();
  const { fullFixelData } = useContext(FixelDataContext);

  const didConnectToPlatforms = () => {
    if (!fullFixelData.install_data) return false;
    const platformsStatus = fullFixelData?.install_data?.options;
    return platformsStatus?.gapi || platformsStatus?.ms || platformsStatus?.pt;
  };
  const didIntegrateFacebook = () => {
    return (
        fullFixelData.facebook &&
        fullFixelData.facebook.status === "connected" &&
        fullFixelData.install_data.options.fb
    );
  };

  const didTrackConversions = () => {
    return fullFixelData.conversions && fullFixelData.conversions.enabled;
  };

  return (
      <Container>
        <SetupAccount />
        <Title>Let’s Get You Started</Title>
        <Checklist>
          <li>
            <ListItem label="Install the Fixel app" checked={true} />
            <Button type="button" checked={true} disabled={true}>
              Installed
            </Button>
          </li>
          <li>
            <ListItem label="Facebook Ads integration" checked={didIntegrateFacebook()} />
            <Button type="button" onClick={() => history.push("/setup/facebook")}>
              {didIntegrateFacebook() ? "Edit" : "Integrate"}
            </Button>
          </li>
          <li>
            <ListItem label="Additional ad platforms" checked={didConnectToPlatforms()} />
            <Button type="button" onClick={() => history.push("/setup/connectPlatforms")}>
              {didConnectToPlatforms() ? "Edit" : "Integrate"}
            </Button>
          </li>
          {/*<li>*/}
          {/*  <ListItem label="Track conversions" checked={didTrackConversions()} />*/}
          {/*  <Button type="button" onClick={() => history.push("/setup/conversions")}>*/}
          {/*    {didTrackConversions() ? "Edit" : "Track"}*/}
          {/*  </Button>*/}
          {/*</li>*/}
        </Checklist>
        <StyledDoThisLater onClick={() => history.push("/dashboard")}>
          {didTrackConversions() || didConnectToPlatforms() ? `I’m done` : "I’ll do this later"}
        </StyledDoThisLater>
      </Container>
  );
};
export default Setup;
